import { render, staticRenderFns } from "./InviteClientButtons.vue?vue&type=template&id=7cf1f52a&scoped=true&"
import script from "./InviteClientButtons.vue?vue&type=script&lang=js&"
export * from "./InviteClientButtons.vue?vue&type=script&lang=js&"
import style0 from "./InviteClientButtons.vue?vue&type=style&index=0&id=7cf1f52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf1f52a",
  null
  
)

export default component.exports